import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { register } from 'swiper/element/bundle';
import { environment } from './environments/environment';

// Register Swiper custom elements before Angular bootstraps so that
// swiper-container / swiper-slide are known when components first render.
register();

// Set the dynamic base href
const baseHrefTag = document?.getElementsByTagName('base')[0];
baseHrefTag.href = environment.baseHref;

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
